/* LED Mirrors Collection — UI Logic */
(function () {
  'use strict';

  const DATA = window.LED_MIRROR_DATA;
  if (!DATA) { console.error('LED_MIRROR_DATA not loaded'); return; }

  const MIN_QTY = 2; // hide sizes with qty <= this

  const STYLE_IMG_BASE    = 'https://hive.mirrorsandmarble.com/static/marble/';
  const STYLE_IMG_FALLBACK = STYLE_IMG_BASE + 'lighted-mirror-transparent.png';

  function styleImg(name) {
    return STYLE_IMG_BASE + name.toLowerCase() + '-thumb.png';
  }

  function dimLabel(label) {
    // "22" × 62"" → "22"w × 62"h"
    return label.replace(/^(\d+")\s*([×x])\s*(\d+")$/, '$1w $2 $3h');
  }

  var BORDERED_STYLES    = ['Lexington'];
  var SMALL_THUMB_STYLES = ['Largo', 'Lakeland'];

  function imgBorderClass(name) {
    return BORDERED_STYLES.indexOf(name) !== -1 ? ' lm-img-bordered' : '';
  }
  function imgSizeClass(name) {
    return SMALL_THUMB_STYLES.indexOf(name) !== -1 ? ' lm-img-small' : '';
  }
  function imgClasses(base, name) {
    return base + imgBorderClass(name) + imgSizeClass(name);
  }

  function styleImgEl(name, className) {
    var img = document.createElement('img');
    img.className = className;
    img.src = styleImg(name);
    img.alt = name;
    img.onerror = function () { this.src = STYLE_IMG_FALLBACK; this.onerror = null; };
    return img;
  }

  /* ── DOM refs ── */
  const sidebar         = document.getElementById('lm-sidebar');
  const tabBtns         = document.querySelectorAll('.lm-tab');
  const panelStyle      = document.getElementById('lm-panel-style');
  const panelSize       = document.getElementById('lm-panel-size');
  const stylePickerEl   = document.getElementById('lm-style-picker');
  const middleEl        = document.getElementById('lm-middle');
  const middleEmpty     = document.getElementById('lm-middle-empty');
  const sizePicker      = document.getElementById('lm-size-picker');
  const styleThumbsEl   = document.getElementById('lm-style-thumbs');
  const styleThumbsHead = document.getElementById('lm-style-thumbs-head');
  const styleThumbsGrid = document.getElementById('lm-style-thumbs-grid');
  const list2pc         = document.getElementById('lm-list-2pc');
  const list1pc         = document.getElementById('lm-list-1pc');
  const sliderMaxWEl    = document.getElementById('lm-max-w');
  const sliderMaxHEl    = document.getElementById('lm-max-h');
  const sliderMaxWVal   = document.getElementById('lm-max-w-val');
  const sliderMaxHVal   = document.getElementById('lm-max-h-val');
  const introEl         = document.getElementById('lm-intro');
  const productEl       = document.getElementById('lm-product');
  const bysizePanel     = document.getElementById('lm-bysize-panel');

  var bysizeSelectedLabel = null;
  var bysizeSelectedPt    = null;

  let activeTab    = 'style';
  let activeStyle  = null;
  let activeVid    = null;

  /* ── Header height offset ── */
  function headerHeight() {
    const h = document.querySelector('header') || document.querySelector('.site-header') || document.querySelector('#shopify-section-header');
    return h ? h.getBoundingClientRect().height : 0;
  }

  function applySidebarTop() {
    const h = headerHeight();
    if (h > 0) {
      var offset = 'calc(100vh - ' + h + 'px)';
      [sidebar, middleEl].forEach(function (el) {
        if (!el) return;
        el.style.top    = h + 'px';
        el.style.height = offset;
      });
    }
  }

  /* ── Tabs ── */
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      activeTab = btn.dataset.tab;

      if (activeTab === 'style') {
        panelStyle.style.display    = '';
        panelSize.style.display     = 'none';
        styleThumbsEl.style.display = 'none';
        middleEl.style.display      = '';
        sidebar.classList.remove('lm-sidebar--wide');
        if (activeStyle) {
          sizePicker.style.display  = 'block';
          middleEmpty.style.display = 'none';
        } else {
          sizePicker.style.display  = 'none';
          middleEmpty.style.display = '';
        }
      } else {
        panelStyle.style.display    = 'none';
        panelSize.style.display     = '';
        sizePicker.style.display    = 'none';
        middleEmpty.style.display   = 'none';
        styleThumbsEl.style.display = 'none';
        middleEl.style.display      = 'none';
        sidebar.classList.add('lm-sidebar--wide');
        showIntro();
      }
    });
  });

  function styleLabel(name) {
    var series = DATA.styleSeries && DATA.styleSeries[name];
    return series ? name + ' • ' + series : name;
  }

  /* ── Build style thumbnail picker ── */
  function renderStylePicker(selected) {
    var others = DATA.styleOrder.filter(function (s) { return s !== selected; });

    var featuredHtml =
      '<div class="lm-featured-wrap">' +
        '<img class="' + imgClasses('lm-featured-img', selected) + '" src="' + styleImg(selected) + '" alt="' + selected + '" onerror="this.src=\'' + STYLE_IMG_FALLBACK + '\';this.onerror=null">' +
        '<div class="lm-featured-name">' + styleLabel(selected) + '</div>' +
      '</div>';

    var othersHtml = '<div class="lm-other-styles">';
    others.forEach(function (s) {
      othersHtml +=
        '<div class="lm-other-style" data-style="' + s + '">' +
          '<img class="' + imgClasses('lm-other-style-img', s) + '" src="' + styleImg(s) + '" alt="' + s + '" onerror="this.src=\'' + STYLE_IMG_FALLBACK + '\';this.onerror=null">' +
          '<div class="lm-other-style-name">' + styleLabel(s) + '</div>' +
        '</div>';
    });
    othersHtml += '</div>';

    stylePickerEl.innerHTML = featuredHtml + othersHtml;

    stylePickerEl.querySelectorAll('.lm-other-style').forEach(function (el) {
      el.addEventListener('click', function () { selectStyle(el.dataset.style); });
    });
  }

  function selectStyle(style, skipAutoLoad) {
    activeStyle = style;
    activeVid   = null;

    renderStylePicker(style);

    // Populate size blocks in middle column
    var styleData = DATA.styles[style];
    populateSizes2PC(list2pc, styleData['2PC']);
    populateSizes(list1pc, styleData['1PC'], '1PC');
    applySizeFilter();

    sizePicker.style.display      = 'block';
    middleEmpty.style.display     = 'none';
    styleThumbsEl.style.display   = 'none';

    if (skipAutoLoad) {
      showIntro();
      return;
    }

    // Auto-select the first visible size button
    var firstBtn = null;
    [list2pc, list1pc].forEach(function (container) {
      if (firstBtn) return;
      var btns = container.querySelectorAll('.lm-size-btn');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].style.display !== 'none') { firstBtn = btns[i]; break; }
      }
    });
    if (firstBtn) { firstBtn.click(); } else { showIntro(); }
  }

  function populateSizes(container, sizes, pieceType) {
    container.innerHTML = '';
    var visible = sizes.filter(function (s) { return s.qty > MIN_QTY; });
    if (visible.length === 0) {
      var empty = document.createElement('div');
      empty.className = 'lm-size-empty';
      empty.textContent = 'None available';
      container.appendChild(empty);
      return;
    }
    if (pieceType === '1PC') {
      var block1 = document.createElement('div');
      block1.className = 'lm-size-orient-block';
      var lbl1 = document.createElement('div');
      lbl1.className = 'lm-size-orient-label';
      lbl1.textContent = '1 Piece  Reversible';
      block1.appendChild(lbl1);
      var row1 = document.createElement('div');
      row1.className = 'lm-size-orient-btns';
      visible.forEach(function (size) { row1.appendChild(makeSizeBtn(size, pieceType)); });
      block1.appendChild(row1);
      container.appendChild(block1);
      return;
    }
    visible.forEach(function (size) {
      container.appendChild(makeSizeBtn(size, pieceType));
    });
  }

  /* ── Style thumbnails for middle panel (Shop by Size mode) ── */
  function buildStyleThumbsMiddle(selectedLabel, selectedPt) {
    styleThumbsGrid.innerHTML = '';

    if (!selectedLabel) {
      styleThumbsHead.textContent = 'Choose a style';
    } else {
      styleThumbsHead.textContent = selectedLabel + ' — choose a style';
    }

    DATA.styleOrder.forEach(function (style) {
      var entry = null;
      if (selectedLabel && selectedPt) {
        var list = DATA.styles[style][selectedPt] || [];
        entry = null;
        for (var i = 0; i < list.length; i++) {
          if (list[i].label === selectedLabel && list[i].qty > MIN_QTY) {
            entry = list[i];
            break;
          }
        }
      }

      var available = !selectedLabel || !!entry;

      var wrap = document.createElement('div');
      wrap.className = 'lm-style-thumb-wrap' + (available ? '' : ' unavailable');

      var img = styleImgEl(style, 'lm-style-thumb-img');

      var overlay = document.createElement('div');
      overlay.className = 'lm-unavail-overlay';

      var name = document.createElement('div');
      name.className = 'lm-style-thumb-name';
      name.textContent = styleLabel(style);

      wrap.appendChild(img);
      wrap.appendChild(overlay);
      wrap.appendChild(name);

      if (available && entry) {
        wrap.addEventListener('click', function () {
          loadProduct(entry.handle, entry.vid, selectedPt, selectedLabel);
        });
      }

      styleThumbsGrid.appendChild(wrap);
    });
  }

  function populateSizes2PC(container, sizes) {
    container.innerHTML = '';
    var visible = sizes.filter(function (s) { return s.qty > MIN_QTY; });
    if (visible.length === 0) {
      var empty = document.createElement('div');
      empty.className = 'lm-size-empty';
      empty.textContent = 'None available';
      container.appendChild(empty);
      return;
    }

    var groups = { Vertical: [], Square: [], Horizontal: [] };
    visible.forEach(function (s) {
      if (s.l > s.w)        groups.Vertical.push(s);
      else if (s.l === s.w) groups.Square.push(s);
      else                  groups.Horizontal.push(s);
    });

    var firstGroup = true;
    ['Vertical', 'Square', 'Horizontal'].forEach(function (name) {
      var items = groups[name];
      if (items.length === 0) return;

      var block = document.createElement('div');
      block.className = 'lm-size-orient-block';

      var lbl = document.createElement('div');
      lbl.className = 'lm-size-orient-label';
      var needsPrefix = (name === 'Vertical' || name === 'Horizontal');
      lbl.textContent = needsPrefix ? '2 Piece  ' + name : name;
      firstGroup = false;
      block.appendChild(lbl);

      var row = document.createElement('div');
      row.className = 'lm-size-orient-btns';
      items.forEach(function (size) {
        row.appendChild(makeSizeBtn(size, '2PC'));
      });
      block.appendChild(row);

      container.appendChild(block);
    });
  }

  function makeSizeBtn(size, pieceType) {
    var btn = document.createElement('button');
    btn.className = 'lm-size-btn';
    if (pieceType === '1PC' && size.w !== size.l) {
      btn.textContent = size.w + '″ × ' + size.l + '″ or ' + size.l + '″ × ' + size.w + '″';
    } else {
      btn.textContent = dimLabel(size.label);
    }
    btn.dataset.handle = size.handle;
    btn.dataset.vid    = size.vid;
    btn.dataset.pt     = pieceType;
    btn.dataset.label  = size.label;
    btn.dataset.w      = size.w;
    btn.dataset.l      = size.l;
    btn.addEventListener('click', function () { selectSize(btn, size, pieceType); });
    return btn;
  }

  /* ── Width sliders ── */
  function initSliders() {
    if (!sliderMaxWEl || !sliderMaxHEl) return;

    // Compute global max width and max height from all in-stock sizes
    var allW = [], allH = [];
    DATA.styleOrder.forEach(function (style) {
      ['2PC', '1PC'].forEach(function (pt) {
        (DATA.styles[style][pt] || []).forEach(function (s) {
          if (s.qty > MIN_QTY) {
            if (allW.indexOf(s.w) === -1) allW.push(s.w);
            if (allH.indexOf(s.l) === -1) allH.push(s.l);
          }
        });
      });
    });
    allW.sort(function (a, b) { return a - b; });
    allH.sort(function (a, b) { return a - b; });

    var maxW = allW[allW.length - 1];
    var maxH = allH[allH.length - 1];

    sliderMaxWEl.min = allW[0];
    sliderMaxWEl.max = maxW;
    sliderMaxWEl.value = maxW;

    sliderMaxHEl.min = allH[0];
    sliderMaxHEl.max = maxH;
    sliderMaxHEl.value = maxH;

    sliderMaxWVal.textContent = maxW + '"';
    sliderMaxHVal.textContent = maxH + '"';

    sliderMaxWEl.addEventListener('input', function () {
      sliderMaxWVal.textContent = sliderMaxWEl.value + '"';
      applySizeFilter();
    });
    sliderMaxHEl.addEventListener('input', function () {
      sliderMaxHVal.textContent = sliderMaxHEl.value + '"';
      applySizeFilter();
    });
  }

  function applySizeFilter() {
    var maxW = sliderMaxWEl ? parseInt(sliderMaxWEl.value, 10) : 9999;
    var maxH = sliderMaxHEl ? parseInt(sliderMaxHEl.value, 10) : 9999;
    // Show/hide individual buttons; hide orient blocks if all their buttons are hidden
    [list2pc, list1pc].forEach(function (container) {
      if (!container) return;
      container.querySelectorAll('.lm-size-orient-block').forEach(function (block) {
        var btns = block.querySelectorAll('.lm-size-btn');
        var anyVisible = false;
        btns.forEach(function (btn) {
          var w = parseInt(btn.dataset.w, 10);
          var l = parseInt(btn.dataset.l, 10);
          var show = w <= maxW && l <= maxH;
          btn.style.display = show ? '' : 'none';
          if (show) anyVisible = true;
        });
        block.style.display = anyVisible ? '' : 'none';
      });
    });
  }

  function selectSize(btn, size, pieceType) {
    // Deselect all size buttons
    document.querySelectorAll('.lm-size-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');
    activeVid = size.vid;

    loadProduct(size.handle, size.vid, pieceType, size.label);
  }

  /* ── Right panel: product display ── */
  function showIntro() {
    introEl.style.display   = '';
    productEl.style.display = 'none';
  }

  function loadProduct(handle, vid, pieceType, sizeLabel) {
    introEl.style.display   = 'none';
    productEl.style.display = 'block';
    productEl.innerHTML = '<div class="lm-product-loading">Loading…</div>';

    // Update URL — stay on configurator page with pre-selection params
    var url = '/collections/led-mirrors?view=led-mirrors-v2&handle=' + handle + '&vid=' + vid;
    window.history.pushState({ handle: handle, vid: vid }, '', url);

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderProduct(data.product, vid, pieceType, sizeLabel); })
      .catch(function () {
        productEl.innerHTML = '<div class="lm-product-loading">Could not load product.</div>';
      });
  }

  function renderProduct(product, initialVid, pieceType, sizeLabel) {
    var variants  = product.variants || [];
    var startVar  = variants.find(function (v) { return String(v.id) === String(initialVid); }) || variants[0];
    var option1   = startVar ? startVar.option1 : '';

    // Only show variants matching the same orientation/piece-type (option1)
    var relevant  = variants.filter(function (v) { return v.option1 === option1; });

    // Unique option2 (light color) and option3 (dimming) values in order
    var colors   = [];
    var dimmings = [];
    relevant.forEach(function (v) {
      if (colors.indexOf(v.option2) === -1) colors.push(v.option2);
      if (dimmings.indexOf(v.option3) === -1) dimmings.push(v.option3);
    });

    var selColor   = startVar ? startVar.option2 : (colors[0] || '');
    var selDimming = startVar ? startVar.option3 : (dimmings[0] || '');
    var selVar     = startVar;

    var imgs    = product.images || [];
    var handle  = product.handle;

    var badgeClass = pieceType === '2PC' ? 'badge-2pc' : 'badge-1pc';
    var badgeLabel = pieceType === '2PC' ? '2-Piece Set' : '1-Piece Reversible';

    // Build description from body_html
    var descHtml = product.body_html ? product.body_html.trim() : '';

    // Parse spec values from body_html attribute table (old-catalog products),
    // falling back to seriesSpecs for newer products that have no table.
    function parseBodySpecs(html) {
      if (!html || html.indexOf('productAttributes') === -1) return null;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var map = {};
      tmp.querySelectorAll('tr').forEach(function (tr) {
        var tds = tr.querySelectorAll('td');
        if (tds.length < 2) return;
        var label = tds[0].textContent.trim().replace(/:$/, '').toLowerCase();
        var value = tds[1].textContent.trim();
        map[label] = value;
      });
      if (!Object.keys(map).length) return null;

      function extract(key) { return map[key] || null; }

      // Lumens: pull the "Approximate lumens: X" number
      var lumensRaw = extract('led lumens and watts') || extract('lumens');
      var lumens = null;
      if (lumensRaw) {
        var lm = lumensRaw.match(/approx(?:imate)?\s*lumens[:\s]*([\d,]+)/i);
        lumens = lm ? lm[1] + ' lm' : lumensRaw.slice(0, 30);
      }

      // Light Color: pull Kelvin range
      var colorRaw = extract('led color temperature and cri') || extract('color temperature') || extract('led color temperature');
      var lightColor = null;
      if (colorRaw) {
        var kk = colorRaw.match(/([\d,]+)\s*kelvin/gi);
        lightColor = kk ? kk.map(function(k){ return k.replace(/kelvin/i,'K').trim(); }).join(' / ') : colorRaw.slice(0,30);
      }

      // Mount: simplify mounting hardware to "Wall Mount"
      var mountRaw = extract('mounting hardware') || extract('mount') || extract('mirror dimensions / orientation');
      var mount = mountRaw ? 'Wall Mount' : null;

      // Power / Plug: from power/connection field
      var powerRaw = extract('power / connection') || extract('power/connection') || extract('power');
      var power = null, plug = null;
      if (powerRaw) {
        power = /dimmable|dimmer|touch/i.test(powerRaw) ? 'Touch Dimmer' : 'Standard Switch';
        plug  = /plug/i.test(powerRaw) ? 'U.S. Plug Included' : 'Hardwire';
      }

      return { mount: mount, color: lightColor, lumens: lumens, plug: plug, power: power };
    }

    // Spec lookup priority:
    //  1. window.ledMirrorSpecs[vid]  — pushed by Hive SpecEditor (authoritative)
    //  2. body_html attribute table   — old-catalog products
    //  3. DATA.seriesSpecs[style]     — static fallback in data file
    var hiveSpecs  = window.ledMirrorSpecs && window.ledMirrorSpecs[String(initialVid)];
    var bodySpecs  = parseBodySpecs(descHtml);
    var fallback   = DATA.seriesSpecs && DATA.seriesSpecs[activeStyle];
    var resolvedSpecs = {
      mount:  (hiveSpecs && hiveSpecs.mount)  || (bodySpecs && bodySpecs.mount)  || (fallback && fallback.mount),
      color:  (hiveSpecs && hiveSpecs.color)  || (bodySpecs && bodySpecs.color)  || (fallback && fallback.color),
      lumens: (hiveSpecs && hiveSpecs.lumens) || (bodySpecs && bodySpecs.lumens) || (fallback && fallback.lumens),
      plug:   (hiveSpecs && hiveSpecs.plug)   || (bodySpecs && bodySpecs.plug)   || (fallback && fallback.plug),
      power:  (hiveSpecs && hiveSpecs.power)  || (bodySpecs && bodySpecs.power)  || (fallback && fallback.power),
    };

    // ── Build DOM ──
    var wrap = document.createElement('div');
    wrap.className = 'lm-product-inner';

    // ── Mobile-only: reopen the style picker modal ──
    var changeStyleBtn = document.createElement('button');
    changeStyleBtn.type = 'button';
    changeStyleBtn.className = 'lm-mobile-changestyle';
    changeStyleBtn.textContent = '◂ Browse Other Styles';
    changeStyleBtn.addEventListener('click', function () { openMobileModal(activeStyle); });
    wrap.appendChild(changeStyleBtn);

    // ── Row 1: title ──
    var titleRow = document.createElement('div');
    titleRow.className = 'lm-product-title-row';

    var titleEl = document.createElement('h2');
    titleEl.className = 'lm-product-title';
    titleEl.textContent = product.title;
    titleRow.appendChild(titleEl);

    wrap.appendChild(titleRow);

    // ── Row 2: description ──
    if (descHtml) {
      var infoRow = document.createElement('div');
      infoRow.className = 'lm-product-info';
      var desc = document.createElement('div');
      desc.className = 'lm-product-desc';
      desc.innerHTML = descHtml;
      infoRow.appendChild(desc);
      wrap.appendChild(infoRow);
    }

    // ── Row 3: spec badges ──
    if (resolvedSpecs) {
      // Hide Mount for 1D and 2D series (round mirrors — mount orientation n/a)
      var activeSeries = DATA.styleSeries && DATA.styleSeries[activeStyle];
      var showMount = !/[12]D$/i.test(activeSeries || '');

      var badgeDefs = [
        { label: 'Mount',        value: showMount ? resolvedSpecs.mount : null },
        { label: 'Light Color',  value: resolvedSpecs.color  },
        { label: 'Lumens',       value: resolvedSpecs.lumens },
        { label: 'Plug',         value: resolvedSpecs.plug   },
        { label: 'Power Switch', value: resolvedSpecs.power  },
      ];
      var badgeRow = document.createElement('div');
      badgeRow.className = 'lm-product-badges';
      badgeDefs.forEach(function (def) {
        if (!def.value) return;
        var card = document.createElement('div');
        card.className = 'lm-badge';
        var lbl = document.createElement('div');
        lbl.className = 'lm-badge-label';
        lbl.textContent = def.label;
        var val = document.createElement('div');
        val.className = 'lm-badge-value';
        val.textContent = def.value;
        card.appendChild(lbl);
        card.appendChild(val);
        badgeRow.appendChild(card);
      });
      if (badgeRow.children.length) wrap.appendChild(badgeRow);
    }

    // ── Row 3: photos — main image on top + horizontal thumb row below ──
    var photoRow = document.createElement('div');
    photoRow.className = 'lm-product-photo-row';

    var mainImg = document.createElement('div');
    mainImg.className = 'lm-product-main-img';
    mainImg.id = 'lm-main-img';
    if (imgs.length) mainImg.style.backgroundImage = 'url(' + imgs[0].src + ')';

    photoRow.appendChild(mainImg);

    if (imgs.length > 1) {
      var thumbCol = document.createElement('div');
      thumbCol.className = 'lm-product-thumbs';
      imgs.slice(0, 6).forEach(function (img, i) {
        var th = document.createElement('div');
        th.className = 'lm-product-thumb' + (i === 0 ? ' active' : '');
        th.style.backgroundImage = 'url(' + img.src + ')';
        th.dataset.full = img.src;
        th.addEventListener('click', function () {
          thumbCol.querySelectorAll('.lm-product-thumb').forEach(function (t) { t.classList.remove('active'); });
          th.classList.add('active');
          mainImg.style.backgroundImage = 'url(' + img.src + ')';
        });
        thumbCol.appendChild(th);
      });
      photoRow.appendChild(thumbCol);
    }

    wrap.appendChild(photoRow);

    // ── Mobile-only: other sizes for this style ──
    if (activeStyle && DATA.styles && DATA.styles[activeStyle]) {
      var mobileSizes = document.createElement('div');
      mobileSizes.className = 'lm-mobile-sizes';

      var msLabel = document.createElement('div');
      msLabel.className = 'lm-mobile-sizes-label';
      msLabel.textContent = 'Available Sizes';
      mobileSizes.appendChild(msLabel);

      var msButtons = document.createElement('div');
      msButtons.className = 'lm-mobile-sizes-btns';

      ['2PC', '1PC'].forEach(function (pt) {
        var list = (DATA.styles[activeStyle][pt] || []).filter(function (s) { return s.qty > MIN_QTY; });
        list.forEach(function (size) {
          var btn = document.createElement('button');
          btn.className = 'lm-size-btn lm-mobile-size-btn' + (String(size.vid) === String(initialVid) ? ' active' : '');
          if (pt === '1PC' && size.w !== size.l) {
            btn.textContent = size.w + '″ × ' + size.l + '″ or ' + size.l + '″ × ' + size.w + '″';
          } else {
            btn.textContent = dimLabel(size.label);
          }
          btn.addEventListener('click', function () {
            mobileSizes.querySelectorAll('.lm-mobile-size-btn').forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            activeVid = size.vid;
            loadProduct(size.handle, size.vid, pt, size.label);
          });
          msButtons.appendChild(btn);
        });
      });

      mobileSizes.appendChild(msButtons);
      wrap.appendChild(mobileSizes);
    }

    // ── Row 3: variant selectors 50/50 + Add to Cart ──
    var variantRow = document.createElement('div');
    variantRow.className = 'lm-product-variant-row';

    function makeOptGroup(label, options, currentVal, onChange) {
      var group = document.createElement('div');
      group.className = 'lm-variant-group';
      var lbl = document.createElement('div');
      lbl.className = 'lm-variant-label';
      lbl.textContent = label + ': ';
      var selected = document.createElement('span');
      selected.className = 'lm-variant-selected-val';
      selected.textContent = currentVal;
      lbl.appendChild(selected);
      group.appendChild(lbl);
      var opts = document.createElement('div');
      opts.className = 'lm-variant-opts';
      options.forEach(function (val) {
        var btn = document.createElement('button');
        btn.className = 'lm-variant-opt' + (val === currentVal ? ' active' : '');
        btn.textContent = val;
        btn.type = 'button';
        btn.addEventListener('click', function () {
          opts.querySelectorAll('.lm-variant-opt').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          selected.textContent = val;
          onChange(val);
        });
        opts.appendChild(btn);
      });
      group.appendChild(opts);
      return group;
    }

    var cartBtn = document.createElement('button');

    // priceEl lives inside the cart button so syncVariant can update it
    var priceEl = document.createElement('span');
    priceEl.className = 'lm-btn-cart-price';
    priceEl.textContent = selVar ? formatMoney(selVar.price) : '';

    function syncVariant() {
      var v = relevant.find(function (v) {
        return v.option2 === selColor && v.option3 === selDimming;
      });
      if (v) {
        selVar = v;
        priceEl.textContent = formatMoney(v.price);
        cartBtn.dataset.vid = v.id;
      }
    }

    var variantCols = document.createElement('div');
    variantCols.className = 'lm-product-variant-cols';

    if (colors.length > 1) {
      variantCols.appendChild(makeOptGroup('Light Color', colors, selColor, function (val) {
        selColor = val; syncVariant();
      }));
    }

    if (dimmings.length > 1) {
      variantCols.appendChild(makeOptGroup('Dimming Control', dimmings, selDimming, function (val) {
        selDimming = val; syncVariant();
      }));
    }

    if (variantCols.children.length) variantRow.appendChild(variantCols);

    cartBtn.className = 'lm-btn-cart';
    cartBtn.type = 'button';
    cartBtn.dataset.vid = selVar ? String(selVar.id) : '';

    var cartLabelEl = document.createElement('span');
    cartLabelEl.className = 'lm-btn-cart-label';
    cartLabelEl.textContent = 'Add to Cart';
    cartBtn.appendChild(cartLabelEl);
    cartBtn.appendChild(priceEl);

    cartBtn.addEventListener('click', function () {
      var vid = cartBtn.dataset.vid;
      if (!vid) return;
      cartLabelEl.textContent = 'Adding…';
      priceEl.style.display = 'none';
      cartBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: Number(vid), quantity: 1})
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function () {
        cartLabelEl.textContent = '✓ Added';
        cartBtn.classList.add('added');
        if (window.jQuery) {
          jQuery('body').trigger('drawer.open');
          if (window.ajaxCart) ajaxCart.load();
        }
        setTimeout(function () {
          cartLabelEl.textContent = 'Add to Cart';
          priceEl.style.display = '';
          cartBtn.classList.remove('added');
          cartBtn.disabled = false;
        }, 2500);
      })
      .catch(function () {
        cartLabelEl.textContent = 'Error — try again';
        priceEl.style.display = '';
        cartBtn.disabled = false;
      });
    });

    var actions = document.createElement('div');
    actions.className = 'lm-product-actions';
    actions.appendChild(cartBtn);

    var pdpBtn = document.createElement('a');
    pdpBtn.className = 'lm-btn-secondary lm-btn-pdp';
    pdpBtn.href = '/products/' + handle;
    pdpBtn.innerHTML = 'Open Product Page' +
      '<svg class="lm-btn-pdp-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    actions.appendChild(pdpBtn);
    variantRow.appendChild(actions);
    wrap.appendChild(variantRow);
    productEl.innerHTML = '';
    productEl.appendChild(wrap);
  }

  function formatMoney(price) {
    return '$' + parseFloat(price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Shop by Size panel (left sidebar) ── */
  function buildBySizePanel() {
    if (!bysizePanel) return;
    bysizePanel.innerHTML = '';

    // ── Sliders (side by side) ──
    var slidersDiv = document.createElement('div');
    slidersDiv.className = 'lm-bs-sliders-row';
    slidersDiv.innerHTML =
      '<div class="lm-slider-half">' +
        '<div class="lm-slider-label">Max Width <span id="lm-bs-max-w-val"></span></div>' +
        '<input type="range" id="lm-bs-max-w" class="lm-range">' +
      '</div>' +
      '<div class="lm-slider-half">' +
        '<div class="lm-slider-label">Max Height <span id="lm-bs-max-h-val"></span></div>' +
        '<input type="range" id="lm-bs-max-h" class="lm-range">' +
      '</div>';
    bysizePanel.appendChild(slidersDiv);

    // ── Style rows (paired groups) ──
    // stacked:true → styles share a bordered group but each gets its own full-width sub-row
    var rowGroups = [
      { styles: ['Liberty'] },
      { styles: ['Lexington', 'Lincoln'], stacked: true },
      { styles: ['Largo',     'Lakeland'] },
      { styles: ['Linden',    'Laurel'] },
    ];

    var rowsDiv = document.createElement('div');
    rowsDiv.className = 'lm-bs-rows';

    function buildSizeBtns(style, container) {
      // Collect unique sizes across 2PC then 1PC, deduped by w×l, sorted by width then height
      var seen = {};
      var sizes = [];
      ['2PC', '1PC'].forEach(function (pt) {
        (DATA.styles[style][pt] || []).forEach(function (size) {
          if (size.qty <= MIN_QTY) return;
          var key = size.w + 'x' + size.l;
          if (!seen[key]) {
            seen[key] = true;
            sizes.push({ size: size, pt: pt });
          }
        });
      });
      sizes.sort(function (a, b) {
        return a.size.w - b.size.w || a.size.l - b.size.l;
      });
      sizes.forEach(function (entry) {
        var size = entry.size, pt = entry.pt;
        var btn = document.createElement('button');
        btn.className = 'lm-size-btn lm-bs-size-btn';
        btn.textContent = dimLabel(size.label);
        btn.dataset.w = size.w;
        btn.dataset.l = size.l;
        btn.addEventListener('click', function () {
          document.querySelectorAll('.lm-bs-size-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          activeStyle = style;
          loadProduct(size.handle, size.vid, pt, size.label);
        });
        container.appendChild(btn);
      });
    }

    function buildStyleCell(style) {
      var cell = document.createElement('div');
      cell.className = 'lm-bs-cell';
      cell.dataset.style = style;

      // Label above
      var nameEl = document.createElement('div');
      nameEl.className = 'lm-bs-row-name';
      nameEl.textContent = styleLabel(style);
      cell.appendChild(nameEl);

      // Thumb + buttons on same baseline
      var innerDiv = document.createElement('div');
      innerDiv.className = 'lm-bs-cell-inner';

      var thumb = document.createElement('img');
      thumb.className = imgClasses('lm-bs-row-thumb', style);
      thumb.src = styleImg(style);
      thumb.alt = style;
      thumb.onerror = function () { this.src = STYLE_IMG_FALLBACK; this.onerror = null; };
      innerDiv.appendChild(thumb);

      var btnsDiv = document.createElement('div');
      btnsDiv.className = 'lm-bs-row-btns';
      buildSizeBtns(style, btnsDiv);
      innerDiv.appendChild(btnsDiv);

      cell.appendChild(innerDiv);
      return cell;
    }

    rowGroups.forEach(function (group) {
      if (group.stacked) {
        // Stacked: each style gets its own horizontal sub-row inside a shared group block
        var block = document.createElement('div');
        block.className = 'lm-bs-row lm-bs-row--stacked';

        group.styles.forEach(function (style, i) {
          if (i > 0) {
            var sep = document.createElement('div');
            sep.className = 'lm-bs-stack-sep';
            block.appendChild(sep);
          }
          var subRow = document.createElement('div');
          subRow.className = 'lm-bs-subrow';
          subRow.dataset.style = style;

          // Label above
          var nameEl = document.createElement('div');
          nameEl.className = 'lm-bs-row-name';
          nameEl.textContent = styleLabel(style);
          subRow.appendChild(nameEl);

          // Thumb + buttons on same baseline
          var innerDiv = document.createElement('div');
          innerDiv.className = 'lm-bs-cell-inner';

          var thumb = document.createElement('img');
          thumb.className = imgClasses('lm-bs-row-thumb', style);
          thumb.src = styleImg(style);
          thumb.alt = style;
          thumb.onerror = function () { this.src = STYLE_IMG_FALLBACK; this.onerror = null; };
          innerDiv.appendChild(thumb);

          var btnsDiv = document.createElement('div');
          btnsDiv.className = 'lm-bs-row-btns';
          buildSizeBtns(style, btnsDiv);
          innerDiv.appendChild(btnsDiv);

          subRow.appendChild(innerDiv);
          block.appendChild(subRow);
        });

        rowsDiv.appendChild(block);

      } else {
        // Side-by-side (50/50) or solo
        var row = document.createElement('div');
        row.className = 'lm-bs-row' + (group.styles.length > 1 ? ' lm-bs-row--paired' : '');

        group.styles.forEach(function (style, i) {
          if (i > 0) {
            var divider = document.createElement('div');
            divider.className = 'lm-bs-cell-divider';
            row.appendChild(divider);
          }
          row.appendChild(buildStyleCell(style));
        });

        rowsDiv.appendChild(row);
      }
    });

    bysizePanel.appendChild(rowsDiv);

    // ── Init bysize sliders ──
    var bsMaxWEl  = document.getElementById('lm-bs-max-w');
    var bsMaxHEl  = document.getElementById('lm-bs-max-h');
    var bsMaxWVal = document.getElementById('lm-bs-max-w-val');
    var bsMaxHVal = document.getElementById('lm-bs-max-h-val');

    var allW = [], allH = [];
    DATA.styleOrder.forEach(function (style) {
      ['2PC', '1PC'].forEach(function (pt) {
        (DATA.styles[style][pt] || []).forEach(function (s) {
          if (s.qty > MIN_QTY) {
            if (allW.indexOf(s.w) === -1) allW.push(s.w);
            if (allH.indexOf(s.l) === -1) allH.push(s.l);
          }
        });
      });
    });
    allW.sort(function (a, b) { return a - b; });
    allH.sort(function (a, b) { return a - b; });

    bsMaxWEl.min = allW[0]; bsMaxWEl.max = allW[allW.length - 1]; bsMaxWEl.value = allW[allW.length - 1];
    bsMaxHEl.min = allH[0]; bsMaxHEl.max = allH[allH.length - 1]; bsMaxHEl.value = allH[allH.length - 1];
    bsMaxWVal.textContent = bsMaxWEl.value + '"';
    bsMaxHVal.textContent = bsMaxHEl.value + '"';

    function applyBsFilter() {
      var maxW = parseInt(bsMaxWEl.value, 10);
      var maxH = parseInt(bsMaxHEl.value, 10);

      function filterUnit(el) {
        var btns = el.querySelectorAll('.lm-bs-size-btn');
        var any = false;
        btns.forEach(function (btn) {
          var show = parseInt(btn.dataset.w, 10) <= maxW && parseInt(btn.dataset.l, 10) <= maxH;
          btn.style.display = show ? '' : 'none';
          if (show) any = true;
        });
        el.style.display = any ? '' : 'none';
        return any;
      }

      rowsDiv.querySelectorAll('.lm-bs-row').forEach(function (row) {
        var anyVisible = false;
        // Stacked rows contain subrows
        row.querySelectorAll('.lm-bs-subrow').forEach(function (sub) {
          if (filterUnit(sub)) anyVisible = true;
        });
        // Side-by-side rows contain cells
        row.querySelectorAll('.lm-bs-cell').forEach(function (cell) {
          if (filterUnit(cell)) anyVisible = true;
        });
        // Solo rows have buttons directly
        if (!row.querySelector('.lm-bs-subrow') && !row.querySelector('.lm-bs-cell')) {
          anyVisible = filterUnit(row);
        }
        row.style.display = anyVisible ? '' : 'none';
      });
    }

    bsMaxWEl.addEventListener('input', function () { bsMaxWVal.textContent = bsMaxWEl.value + '"'; applyBsFilter(); });
    bsMaxHEl.addEventListener('input', function () { bsMaxHVal.textContent = bsMaxHEl.value + '"'; applyBsFilter(); });
  }

  /* ── Mobile style → size picker modal ── */
  var mmModal    = document.getElementById('lm-mmodal');
  var mmTrack    = document.getElementById('lm-mmodal-track');
  var mmViewport = document.getElementById('lm-mmodal-viewport');
  var mmDots     = document.getElementById('lm-mmodal-dots');
  var mmSizes    = document.getElementById('lm-mmodal-sizes');
  var mmPrev     = document.getElementById('lm-mmodal-prev');
  var mmNext     = document.getElementById('lm-mmodal-next');
  var mmClose    = document.getElementById('lm-mmodal-close');
  var mmIndex    = 0;
  var mmBuilt    = false;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function buildMobileModal() {
    if (mmBuilt || !mmTrack) return;

    DATA.styleOrder.forEach(function (style, idx) {
      var slide = document.createElement('div');
      slide.className = 'lm-mmodal-slide';
      slide.dataset.style = style;
      slide.appendChild(styleImgEl(style, imgClasses('lm-mmodal-slide-img', style)));
      var name = document.createElement('div');
      name.className = 'lm-mmodal-slide-name';
      name.textContent = styleLabel(style);
      slide.appendChild(name);
      mmTrack.appendChild(slide);

      var dot = document.createElement('div');
      dot.className = 'lm-mmodal-dot';
      dot.dataset.index = idx;
      dot.addEventListener('click', function () { mmGoTo(idx); });
      mmDots.appendChild(dot);
    });

    mmPrev.addEventListener('click', function () { mmGoTo(mmIndex - 1); });
    mmNext.addEventListener('click', function () { mmGoTo(mmIndex + 1); });
    mmClose.addEventListener('click', closeMobileModal);
    mmModal.addEventListener('click', function (e) {
      if (e.target === mmModal) closeMobileModal();
    });
    attachMobileSwipe();
    mmBuilt = true;
  }

  function mmGoTo(i) {
    var n = DATA.styleOrder.length;
    mmIndex = (i % n + n) % n;
    mmTrack.style.transform = 'translateX(' + (-mmIndex * 100) + '%)';
    mmDots.querySelectorAll('.lm-mmodal-dot').forEach(function (d, idx) {
      d.classList.toggle('active', idx === mmIndex);
    });
    renderMobileModalSizes(DATA.styleOrder[mmIndex]);
  }

  function renderMobileModalSizes(style) {
    mmSizes.innerHTML = '';

    var head = document.createElement('div');
    head.className = 'lm-mmodal-sizes-head';
    head.textContent = 'Available Sizes';
    mmSizes.appendChild(head);

    var any = false;
    [['2PC', '2 Piece'], ['1PC', '1 Piece  Reversible']].forEach(function (pair) {
      var pt   = pair[0];
      var list = (DATA.styles[style][pt] || []).filter(function (s) { return s.qty > MIN_QTY; });
      if (!list.length) return;
      any = true;

      var block = document.createElement('div');
      block.className = 'lm-mmodal-size-block';
      var lbl = document.createElement('div');
      lbl.className = 'lm-mmodal-size-block-label';
      lbl.textContent = pair[1];
      block.appendChild(lbl);

      var btns = document.createElement('div');
      btns.className = 'lm-mmodal-size-btns';
      list.forEach(function (size) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lm-size-btn';
        if (pt === '1PC' && size.w !== size.l) {
          btn.textContent = size.w + '″ × ' + size.l + '″ or ' + size.l + '″ × ' + size.w + '″';
        } else {
          btn.textContent = dimLabel(size.label);
        }
        btn.addEventListener('click', function () { chooseMobileSize(style, size, pt); });
        btns.appendChild(btn);
      });
      block.appendChild(btns);
      mmSizes.appendChild(block);
    });

    if (!any) {
      var empty = document.createElement('div');
      empty.className = 'lm-size-empty';
      empty.textContent = 'None available in this style';
      mmSizes.appendChild(empty);
    }
  }

  function chooseMobileSize(style, size, pieceType) {
    activeStyle = style;
    selectStyle(style, true);   // keep desktop pickers in sync; no auto-load
    loadProduct(size.handle, size.vid, pieceType, size.label);
    closeMobileModal();
  }

  function openMobileModal(startStyle) {
    if (!mmModal) return;
    buildMobileModal();
    var idx = startStyle ? DATA.styleOrder.indexOf(startStyle) : 0;
    mmGoTo(idx < 0 ? 0 : idx);
    mmModal.classList.add('open');
    mmModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileModal() {
    if (!mmModal) return;
    mmModal.classList.remove('open');
    mmModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function attachMobileSwipe() {
    var startX = 0, startY = 0, dx = 0, dragging = false;
    mmViewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      dragging = true;
      mmTrack.style.transition = 'none';
    }, { passive: true });
    mmViewport.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) < Math.abs(dy)) return; // let vertical scrolling win
      var pct = dx / mmViewport.offsetWidth * 100;
      mmTrack.style.transform = 'translateX(' + (-mmIndex * 100 + pct) + '%)';
    }, { passive: true });
    mmViewport.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      mmTrack.style.transition = '';
      if (Math.abs(dx) > mmViewport.offsetWidth * 0.18) {
        mmGoTo(mmIndex + (dx < 0 ? 1 : -1));
      } else {
        mmGoTo(mmIndex);
      }
    });
  }

  /* ── Init ── */
  applySidebarTop();
  initSliders();
  buildBySizePanel();

  // Pre-select from URL params (?handle=...&vid=...)
  (function () {
    var params  = new URLSearchParams(window.location.search);
    var handle  = params.get('handle');
    var vid     = params.get('vid');
    var matched = false;

    if (handle && vid) {
      DATA.styleOrder.forEach(function (style) {
        if (matched) return;
        ['2PC', '1PC'].forEach(function (pt) {
          if (matched) return;
          (DATA.styles[style][pt] || []).forEach(function (size) {
            if (matched) return;
            if (size.handle === handle) {
              selectStyle(style, true);
              // Find the rendered button and trigger selection
              var btn = (pt === '2PC' ? list2pc : list1pc)
                          .querySelector('[data-handle="' + handle + '"]');
              if (btn) {
                btn.classList.add('active');
                loadProduct(handle, vid, pt, size.label);
              }
              matched = true;
            }
          });
        });
      });
    }

    if (!matched) selectStyle('Liberty');

    // Mobile: open the style → size picker modal on load
    // (skip when deep-linked to a specific product via ?handle=&vid=)
    if (isMobile() && !matched) {
      openMobileModal(activeStyle || 'Liberty');
    }
  }());

  window.addEventListener('resize', applySidebarTop);

}());
